if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.birdieSubscription = document.querySelector('.subscription-element');

      this.form = this.querySelector('form');
      // this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-drawer-new');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') || document.querySelector('cart-drawer-new')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    uniqueID(){
      function chr4(){
      return (Date.now() * Math.random()).toString(16).slice(0,4).toUpperCase();
      }
      return chr4() + '-' + chr4() + '-' + chr4()
    }

    upsellProduct(formData) {
      console.log('upsellProduct')
      console.log(formData)

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
        this.error = false;
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      })

      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      const sectionRender = this.cart.getSectionsToRender().map((section) => section.id);
      
      if (this.cart) {
        formData.append('sections', sectionRender);
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let inputValue = document.querySelector('input[name="id"]').value;

      const UID = this.uniqueID()

      if (this.birdieSubscription) {
        let upsellFormData;
          upsellFormData = {
            items: [
              {
                id: this.birdieSubscription.dataset.subscribe,
                selling_plan: this.birdieSubscription.dataset.selling,
                quantity: 1,
                properties: {
                  '_UID': UID,
                  '_theme': 'med'
                }
              },
              // {
              //   id:  inputValue,
              //   quantity: 1,
              //   properties: {
              //     '_theme': 'med'
              //   }
              // },
            ],
            sections: sectionRender,
            sections_url: window.location.pathname
          };

        this.upsellProduct(upsellFormData);
      } else {
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            console.log(response);
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        })
      }
        console.log(config)
      

      }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.birdieSubscription = document.querySelector('.subscription-element');

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || document.querySelector('cart-drawer-new');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//     }

//     uniqueID(){
//       function chr4(){
//       return (Date.now() * Math.random()).toString(16).slice(0,4).toUpperCase();
//       }
//       return chr4() + '-' + chr4() + '-' + chr4()
//     }

//     upsellProduct(formData) {
//       fetch(window.Shopify.routes.root + "cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       })
//         .then((response) => {
//           return response.json();
//         })
//         .then((response) => {})
//         .catch((error) => {
//           console.error("Error:", error);
//         });
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       console.log(this.cart)

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//       const formData = new FormData(this.form);
//       console.log(formData)

//       const sectionRender = this.cart.getSectionsToRender().map((section) => section.id);

//       console.log(sectionRender);

//       console.log(window.location.pathname);
      
//       if (this.cart) {
//         formData.append('sections', sectionRender);
//         formData.append('sections_url', window.location.pathname);
//         this.cart.setActiveElement(document.activeElement);
//       }

//       config.body = formData;

//       console.log(config.body);


//       let inputValue = document.querySelector('input[name="id"]').value;

//       if (this.birdieSubscription) {
//         let upsellFormData = {
//           items: [
//               {
//               id: this.birdieSubscription.dataset.subscribe,
//               selling_plan: this.birdieSubscription.dataset.selling,
//               quantity: 1,
//               },
//               {
//                 id:  inputValue,
//                 quantity: 1,
//               },
//           ],
//           sections: sectionRender,
//           sections_url: window.location.pathname
//         };
        
//         this.upsellProduct(upsellFormData);
  
//       } else {
//       }
//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);

//             const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//             if (!soldOutMessage) return;
//             this.submitButton.setAttribute('aria-disabled', true);
//             this.submitButton.querySelector('span').classList.add('hidden');
//             soldOutMessage.classList.remove('hidden');
//             this.error = true;
//             return;
//           } else if (!this.cart) {
//             window.location = window.routes.cart_url;
//             return;
//           }

//           if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             console.log(response);
//             this.cart.renderContents(response);
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });

//       }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       if (!this.errorMessageWrapper) return;
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }
